import type { TourDefinition, TourId } from "./types";

export const TOURS: Record<TourId, () => Promise<{ default: TourDefinition }>> =
  {
    aerocarry: () => import("../tours/aerocarry"),
  };

/** The one onboarding: the walkthrough every new user is offered. */
export const DEFAULT_TOUR: TourId = "aerocarry";

/**
 * The name a tour's canvas is created with. A real name at creation is also
 * what keeps the backend auto-namer off it: that only replaces a canvas still
 * called "Untitled", and its write is guarded on the same literal.
 */
export const TOUR_CANVAS_NAME = "Onboarding";
/** The tour canvas's description, and the home card's line while it runs. */
export const TOUR_CANVAS_DESCRIPTION =
  "Pick up the guided tour where you left off";
